"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Sizes", {
  enumerable: true,
  get: function get() {
    return _style.Sizes;
  }
});
exports.StyleTypes = void 0;

var _style = require("../../style");

var StyleTypes = (0, _style.tuple)('default', 'card');
exports.StyleTypes = StyleTypes;